import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const selectPage = (currentPageIndex, sectionPages, props) => {
  const Component = sectionPages[currentPageIndex];

  return <Component {...props} />;
};

const DialogPagesRouter = function DialogPagesRouter({
  currentPage = 0,
  pages = [],
  contact = false, //true if is contact dialog and not Customer or Lead
  ...props
}) {
  const Page = useMemo(
    () => selectPage(currentPage, pages, { ...props, contact }),
    [currentPage, props, pages, contact]
  );

  return Page;
};

DialogPagesRouter.propTypes = {
  currentPage: PropTypes.number,
  pages: PropTypes.array,
  props: PropTypes.object,
};

export default DialogPagesRouter;
